import { useQuery } from '@tanstack/react-query'
import { fetchGovernmentByElection, governmentKeys } from '@/services/governments'

export function useGovernmentByElection(electionId: string | undefined) {
  const query = useQuery({
    queryKey: governmentKeys.byElection(electionId!),
    queryFn: () => fetchGovernmentByElection(electionId!),
    enabled: !!electionId,
  })

  return {
    government: query.data,
    isLoading: query.isLoading,
    error: query.error,
  }
}
